export enum LocalLieState {
    None,
    Pending,
    Complete,
}
